module.exports = __webpack_public_path__ + "img/11.9edf8ee4.jpg";